import {useEffect, useRef, useState} from 'react';

export const useClickOutside = (initialIsVisible: boolean) => {
  const [isComponentVisible, setIsComponentVisible] = useState(initialIsVisible);
  const ref = useRef<HTMLDivElement | null>(null);

  const handleClickOutside = (e: MouseEvent) => {
    if (
      e.target !== document.body &&
      !ref.current?.contains(e.target as Node) &&
      !Array.from(document.querySelectorAll('[role="presentation"]')).some((el) => el.contains(e.target as Node))
    ) {
      setIsComponentVisible(false);
    }
  };

  useEffect(() => {
    if (!ref.current) return;
    document.addEventListener('click', handleClickOutside, true);
    return () => document.removeEventListener('click', handleClickOutside, true);
  }, []);

  return {ref, isComponentVisible, setIsComponentVisible};
};
